module.exports = __webpack_public_path__ + "static/media/kanjia.e75e1077.svg";